var _defs, _rect, _polyline, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpackNew345({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;stroke:#fff;}.a{stroke-linejoin:round;stroke-width:0.41px;}.b{stroke-miterlimit:10;stroke-width:0.5px;}.c{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    x: 3.09,
    y: 3.09,
    width: 9.81,
    height: 9.81
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "b",
    points: "5.97 12.83 10.03 8.92 5.97 7.08 10.03 3.17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M14.75,15H9.84v-.5H14.5V9.84H15v4.91h-.25ZM8.61,15H3.71v-.5h4.9ZM2.48,15H1.25A.25.25,0,0,1,1,14.75V11.07h.5V14.5h1Zm-1-5.16H1V4.93h.5ZM15,8.61h-.5V3.71H15ZM1.5,3.71H1V1.25A.25.25,0,0,1,1.25,1H3.71v.5H1.5ZM15,2.48h-.5v-1H11.07V1h3.68a.25.25,0,0,1,.25.25Zm-5.16-1H4.93V1H9.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpackNew345);
export default __webpack_public_path__ + "static/media/Symbolpack_New_345.9c4850eac567429011718f1bccd1fe5d.svg";
export { ForwardRef as ReactComponent };